export default "__VITE_ASSET__B4Py44Kg__"